import {Injectable} from '@angular/core';
import {BotatoMarkdownService} from 'botato-angular-lib';

@Injectable({
    providedIn: 'root'
})
export class ResponseItemDataTextService {

    private static NEW_LINE_SEPARATOR = ' | ';

    constructor(private markdownService: BotatoMarkdownService) {
    }

    public create<T extends { [K in keyof T]: string }>(responseItemDataText: T): T {
        const text: Record<string, string> = responseItemDataText;
        for (const [key, value] of Object.entries(text)) {
            text[key] = this.replaceText(value);
        }
        return responseItemDataText;
    }

    public replaceText(value: string): string {
        value = value.split(ResponseItemDataTextService.NEW_LINE_SEPARATOR).join('\r\n');
        return this.markdownService.renderMarkdown(value, true);
    }
}
